module.exports = __webpack_public_path__ + "static/media/17.ad6693d2.jpg";